import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";
import Group from "../../models/group.ts";

export default class V1GroupCreated extends BaseIncomingPayload {
  public readonly payload: V1GroupCreatedPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_GROUP_CREATED);

    this.payload = new V1GroupCreatedPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1GroupCreatedPayload {
  public readonly group: Group;

  constructor(payload: Record<string, unknown>) {
    this.group = Group.fromPayload(ParseUtils.parseObject(payload, "group"));
  }
}
